import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';

@IonicPage()
@Component({
  selector: 'page-taskList',
  templateUrl: 'taskList.html',

})
export class TaskListPage {
    private tasks = [];
    private GetWorks = [];
    private TaskName: any;
    private TaskUserNAme: any;
    private TaskBeginDay: any;
    private TaskEndDay : any;
    private TaskUsageTime: any;
    private TaskSpendTime: any;
    private TaskUsageProcess: any;
    private TaskSpendProcess: any;
    private TaskSpendPreson: any;
    private work: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {

  }

  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Таскууд';

    this.rest.GetWorks(this.data.companyId, null, null).subscribe(res => {
      this.GetWorks = res;
    });
  }

  getTasks(){
    this.rest.GetTasks(this.work).subscribe(res => {
      this.tasks = res;
    });
  }
  closeTask(task: any){
    if(confirm('Та тухайн таскыг хаахдаа итгэлтэй байна уу?')){
      this.rest.addTasks(task.id, task.work_id, task.title, task.begin_day, task.end_day, task.usage_time, task.created_user_id, "1", task.member_ids).subscribe(res => {
        if(res.msg == 'ok') {
          this.showToast('Таны сонгосон таск амжилттай хаагдлаа.');
        }
        this.getTasks();
      });
    }
  }
  addTask(task: any){
    let addTask = this.modalCtrl.create(
      ModalAddTaskPage,
      { task: task },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    addTask.present().catch(err => {

    });
    addTask.onDidDismiss((data) => {
      if(data != null) {
        this.getTasks();
      }
    });
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
}
  @Component({
    template: `
    <ion-header text-center style="height: 50px; background-color: #84dac8;">
      <ion-title>Таск</ion-title>
    </ion-header>
    <ion-content text-center>
      <ion-grid>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Прожект сонго</ion-label>
            <ion-select name="Works" [(ngModel)]="workId" (ionChange)="getWorks()" class="border1" style="width: 100%; text-transform: uppercase;">
              <ion-option *ngFor="let work1 of GetWorks" value="{{work1.id}}">{{work1.title}}</ion-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
            <ion-label floating>Таскийн нэр</ion-label>
            <ion-textarea [(ngModel)]="title"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

  <ion-row>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
    <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
      <ion-item>
        <ion-label>Эхлэх хугацаа</ion-label>
        <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="beginDay"></ion-datetime>
    </ion-item>
    </ion-col>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
    <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
      <ion-item>
        <ion-label>Дуусах хугацаа</ion-label>
        <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="endDay"></ion-datetime>
    </ion-item>
    </ion-col>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
  </ion-row>

  <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
            <ion-label floating>Зарцуулах цаг</ion-label>
            <ion-textarea [(ngModel)]="usageTime"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>

  <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <ion-label>Оролцогчид</ion-label>
          <ion-select multiple="true" name="spendPerson" [(ngModel)]="taskMembersIds" (ionChange)="getCmbUser($event)">
              <ion-option *ngFor="let spendPerson of GetCmbUser" value="{{spendPerson.id}}">{{spendPerson.firstname}}</ion-option>
          </ion-select>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
  </ion-row>

  <ion-row>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
    <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
      <ion-item>
      <button class="myButton" (click)="createTasks()" *ngIf="task == null">Үүсгэх</button>
        <button class="myButton" (click)="settingTask()" *ngIf="task !== null">Засах</button>
      </ion-item>
    </ion-col>
    <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
      <ion-item>
      <button class="myButton" (click)="back()">Буцах</button>
      </ion-item>
    </ion-col>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
  </ion-row>

  </ion-grid>
  </ion-content>
    `
  })

  export class  ModalAddTaskPage {
    private taskId: any;
    private workId: any;
    private title: any;
    private beginDay: any;
    private endDay: any;
    private usageTime: any;
    private addTasks: any;
    private isEnd: any;
    private taskMembersIds: any;
    private taskMembersId = '';
    private GetCmbUser = [];
    private GetWorks = [];
    private task: any;
    constructor(public navCtrl: NavController,
      public navParams: NavParams,
      public alertCtrl: AlertController,
      private rest: RestProvider,
      public httpClient: HttpClient,
      private viewCtrl: ViewController,
      private toastCtrl: ToastController,
      private data: DataProvider,){
        this.task = this.navParams.get('task');
        if(this.task != null) {
          this.workId = this.task.work_id;
          this.title = this.task.title;
          this.beginDay = this.task.begin_day;
          this.endDay = this.task.end_day;
          this.usageTime = this.task.usage_time;
          this.taskMembersIds = this.task.member_ids.split(',');
        }
        this.rest.GetCmbUser(this.data.companyId).subscribe(res => {
          this.GetCmbUser = res;
          });
        this.rest.GetWorks(this.data.companyId, null, null).subscribe(res => {
          this.GetWorks = res;
        });
    }
    getCmbUser($event){}
    getWorks($event){}
    createTasks(){
      this.taskMembersId = '';
      if( !this.workId ){
        this.workId == null;
        this.showToast1('Прожект сонгогдоогүй байна!!!');
        return;
      }
      if( !this.title ){
        this.title == null;
        this.showToast1('Таскын нэр бичигдээгүй байна!!!');
        return;
      }
      if( !this.beginDay ){
        this.beginDay == null;
        this.showToast1('Таск эхлэх өдөр сонгогдоогүй байна!!!');
        return;
      }
      if( !this.endDay ){
        this.endDay == null;
        this.showToast1('Таск дуусах өдөр сонгогдоогүй байна!!!');
        return;
      }
      if( !this.usageTime ){
        this.usageTime == null;
        this.showToast1('Таскын зарцуулалтын цаг бичигдээгүй байна!!!');
        return;
      }
      for(let i = 0; i < this.taskMembersIds.length;i++){
        this.taskMembersId = this.taskMembersId + this.taskMembersIds[i].toString();
        if(i < (this.taskMembersIds.length) - 1) {
          this.taskMembersId = this.taskMembersId + ',';
        }
      }
      this.rest.addTasks("", this.workId, this.title, this.beginDay, this.endDay, this.usageTime, this.data.userId, "", this.taskMembersId).subscribe(res => {
         this.addTasks = res;
        if(res.msg == null) {
          this.showToast1('Та Таскын мэдээллээ бүрэн оруулна уу.');
        } else if(res.msg == 'ok') {
          this.showToast('Таск амжилттай үүслээ.');
          this.viewCtrl.dismiss({data: 'edit'});
        } else {
          this.showToast1('Бүртгэлтэй Таск байна.');
        }
      });
    }
    settingTask(){
      this.taskMembersId = '';
      if( !this.workId ){
        this.workId == null;
        this.showToast1('Прожект сонгогдоогүй байна!!!');
        return;
      }
      if( !this.title ){
        this.title == null;
        this.showToast1('Таскын нэр бичигдээгүй байна!!!');
        return;
      }
      if( !this.beginDay ){
        this.beginDay == null;
        this.showToast1('Таск эхлэх өдөр сонгогдоогүй байна!!!');
        return;
      }
      if( !this.endDay ){
        this.endDay == null;
        this.showToast1('Таск дуусах өдөр сонгогдоогүй байна!!!');
        return;
      }
      if( !this.usageTime ){
        this.usageTime == null;
        this.showToast1('Таскын зарцуулалтын цаг бичигдээгүй байна!!!');
        return;
      }
      for(let i = 0; i < this.taskMembersIds.length;i++){
        this.taskMembersId = this.taskMembersId + this.taskMembersIds[i].toString();
        if(i < (this.taskMembersIds.length) - 1) {
          this.taskMembersId = this.taskMembersId + ',';

        }
      }
      this.rest.addTasks(this.task.id, this.workId, this.title, this.beginDay, this.endDay, this.usageTime, this.data.userId, "", this.taskMembersId).subscribe(res => {
        this.showToast('Таск амжилттай засагдлаа.');
        this.viewCtrl.dismiss({data: 'edit'});
      });
    }


    back(){
      this.viewCtrl.dismiss({});
    }
    showToast(str: any) {
      let toast = this.toastCtrl.create({
        message: str,
        position: 'middle',
        duration: 5000,
        cssClass: "toast-success"
      });
      toast.present();
    }
    showToast1(str: any) {
      let toast = this.toastCtrl.create({
        message: str,
        position: 'middle',
        duration: 5000,
        cssClass: "toast-unsuccess"
      });
      toast.present();
    }
  }



// WEBPACK FOOTER //
// ./src/pages/taskList/taskList.ts